import { cn } from "@/lib/utils";

export default function SectionHeader({ eyebrow, title, description, align = "left", className }) {
    const isCenter = align === "center";
    return (
        <div
            className={cn(
                "max-w-3xl",
                isCenter ? "mx-auto text-center" : "text-left",
                className
            )}
        >
            {eyebrow && (
                <div
                    className={cn(
                        "inline-flex items-center gap-2 px-3 py-1 rounded-full border border-border bg-background",
                        isCenter ? "mx-auto" : ""
                    )}
                >
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-glow" />
                    <span className="text-[11px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
                        {eyebrow}
                    </span>
                </div>
            )}
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] font-semibold tracking-tight text-foreground leading-[1.1] text-balance">
                {title}
            </h2>
            {description && (
                <p className="mt-4 text-base lg:text-lg text-muted-foreground leading-relaxed">
                    {description}
                </p>
            )}
        </div>
    );
}
